import {
    useMemo,
} from 'react'
import {
    useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    App,
    AccountManagementDomains,
    RegionalGroupsTabs,
    AccountTabs,
    OpportunitiesTabs,
    AQuotesTab,
    CQuotesTab,
    AssingPricingSubRoutes,
} from 'app/enums/domain.enums'
import {
    createRoutesConfig,
} from 'app/SkyNetRoutes/skyNetRoutes.utils'
import useCreateSkyNetDomainRoutes from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    SkyNetRoutesConfig,
} from 'app/SkyNetRoutes/SkyNetRoutes.types'

export default function useAccountManagementRoutes() {
    const skyNetNavigate = useSkyNetNavigate()
    const SkyNetDomainRoutes = useCreateSkyNetDomainRoutes()()

    return useMemo(() => {
        const config: SkyNetRoutesConfig = {
            path: [App.AccountManagement],
            KamDashboard: {
                route: AccountManagementDomains.KamDashboard,
            },
            Accounts: {
                route: AccountManagementDomains.Accounts,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                RegionalGroups: {
                    route: AccountTabs.RegionalGroups,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Opportunities: {
                    route: AccountTabs.Opportunities,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Lanes: {
                    route: AccountTabs.Lanes,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                AQuotes: {
                    route: AccountTabs.AQuotes,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                CQuotes: {
                    route: AccountTabs.CQuotes,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                BillingCompanies: {
                    route: AccountTabs.BillingCompanies,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Addresses: {
                    route: AccountTabs.Addresses,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Contacts: {
                    route: AccountTabs.Contacts,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ActivityRecords: {
                    route: AccountTabs.ActivityRecords,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            RegionalGroups: {
                route: AccountManagementDomains.RegionalGroups,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.Update,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Opportunities: {
                    route: RegionalGroupsTabs.Opportunities,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            Opportunities: {
                route: AccountManagementDomains.Opportunitites,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Lanes: {
                    route: OpportunitiesTabs.Lanes,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ContainerInformation: {
                    route: OpportunitiesTabs.ContainerInformation,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Create: {
                    route: CommonRoutes.Asterisk,
                    via: SkyNetDomainRoutes.All.Create,
                },
            },
            Lanes: {
                route: AccountManagementDomains.Lanes,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'copy',
                    }],
                },
                Copy: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'copy',
                    }],
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Create: {
                    route: CommonRoutes.Asterisk,
                    via: SkyNetDomainRoutes.All.Create,
                },
            },
            AQuotes: {
                route: AccountManagementDomains.AQuotes,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                AssignQuote: {
                    route: AQuotesTab.AssignQuote,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ReviewGroup: {
                    route: AQuotesTab.ReviewGroup,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                AssignPricing: {
                    route: AQuotesTab.AssignPricing,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'laneGroupId',
                    }],
                    LaneFees: {
                        route: AssingPricingSubRoutes.LaneFees,
                        params: [
                            {
                                name: 'feesId',
                            },
                            {
                                name: 'feesAction',
                            },
                        ],
                    },
                },
                AwardReject: {
                    route: AQuotesTab.AwardReject,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                QuotePdf: {
                    route: AQuotesTab.QuotePdf,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Create: {
                    route: null,
                    via: SkyNetDomainRoutes.All.Create,
                },
            },
            CQuotes: {
                route: AccountManagementDomains.CQuotes,
                Create: {
                    route: null,
                    via: SkyNetDomainRoutes.All.Create,
                    params: [{
                        name: 'selectedMethod',
                        required: false,
                    }],
                },
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                AwardReject: {
                    route: CQuotesTab.AwardReject,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                QuotePdf: {
                    route: CQuotesTab.QuotePdf,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            SimplifiedCQuotes: {
                route: AccountManagementDomains.SimplifiedCQuotes,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                DataUpdate: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            PreBookings: {
                route: AccountManagementDomains.PreBookings,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [
        SkyNetDomainRoutes,
        skyNetNavigate,
    ])
}
